import { render } from "./PagoEnProceso.vue?vue&type=template&id=09d95c0f"
import script from "./PagoEnProceso.vue?vue&type=script&lang=js"
export * from "./PagoEnProceso.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProductFactory\\analiaperez-landing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__